/**
 * Created by wuyanbin on 2019/9/17
 */
import React, { Component } from 'react';
import { Button } from 'antd';
import Authorized from '@/components/Auth/auth';
class OperateBtn extends Component {
    render() {
        const { isCanEdit, cancelEditFun, saveEditFun, editFun, editAllow } = this.props;
        return (<React.Fragment>
        {isCanEdit ?
            <React.Fragment>
            <Button onClick={cancelEditFun} style={{ marginRight: '10px' }}>取消</Button>
            <Button type="primary" onClick={saveEditFun}>保存</Button>
          </React.Fragment> :
            <Authorized allow={editAllow}>
            <Button type="primary" onClick={editFun}>编辑</Button>
          </Authorized>}
      </React.Fragment>);
    }
}
export default OperateBtn;
